import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';

export type OfferDataViewState = {
  autoExpandRows: boolean;
};

const initialState: OfferDataViewState = {
  autoExpandRows: false,
};

const slice = createSlice({
  name: 'gerenciadorPrecos/offerDataView',
  initialState,
  reducers: {
    setAutoExpandOfferRows(state, action: PayloadAction<boolean>) {
      state.autoExpandRows = action.payload;
    },
  },
});

export const { setAutoExpandOfferRows } = slice.actions;

export const selectorOfferDataView = (state: RootState) => state.gerenciadorPrecosReducer.offerDataView;

export default slice.reducer;
